import React from 'react'

import { Icon, IconifyIcon } from '@iconify/react'
import { Box, SxProps } from '@mui/material'

// ----------------------------------------------------------------------

type IconifyPropTypes = {
  icon: IconifyIcon | string
  sx?: SxProps
  width?: number
  height?: number
  className?: string
  // color?: string
}

const Iconify: React.FC<IconifyPropTypes> = ({ icon, ...other }) => {
  return <Box component={Icon} icon={icon} {...other} />
}

export default Iconify
